import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
// API
import { getTrial, startTrial } from './TrialApi';
import { ISection } from '../V2/SectionSlice';
import { ILessonTutorFeedback } from '../V2/LessonTutorFeedbacksSlice';
import { ILessonHistory } from '../V2/LessonHistorySlice';

export interface ITrialState {
  status: 'idle' | 'loading' | 'rejected';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meetingData?: {
    sectionData: ISection;
    tutorFeedback?: ILessonTutorFeedback;
    lessonHistory?: ILessonHistory;
  };
}

const initialState: ITrialState = {
  status: 'idle',
  meetingData: undefined,
};

export const TrialSlice = createSlice({
  name: 'trialSlice',
  initialState,
  reducers: {
    resetMeetingData: (state) => {
      state.meetingData = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startTrial.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(startTrial.fulfilled, (state) => {
        state.status = 'idle';
      })
      .addCase(startTrial.rejected, (state) => {
        state.status = 'rejected';
      })
      .addCase(getTrial.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getTrial.fulfilled, (state, action) => {
        state.status = 'idle';
        state.meetingData = action.payload;
      })
      .addCase(getTrial.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getTrialState = (state: RootState): RootState['trial'] =>
  state.trial;

export const { resetMeetingData } = TrialSlice.actions;

export * from './TrialApi';
export default TrialSlice.reducer;
